import { TableColumnsSetting } from '@/interfaces/table-setting';
import { VwfsCommissionModel } from '@/models/imports/vwfs-commission-model';

export class VwfsCommissionSettingsTable {
  public static getColumnsSetting(): TableColumnsSetting<keyof VwfsCommissionModel> {
    return [
      {
        name: 'id',
        text: 'Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'importId',
        text: 'Import Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'practiceNumber',
        text: 'Num. pratica',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'model',
        text: 'Codice modello',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'targa',
        text: 'Targa',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'chassis',
        text: 'Telaio',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'createdAt',
        type: 'datetime',
        text: 'creato il',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'updatedAt',
        type: 'datetime',
        text: 'modificato il',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }
}
